import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Star } from 'lucide-react';
import { ptDate, daysLeft } from '@/utils/pioneerDates';

const PioneerEndedNotice = ({ endedAt }) => {
  const navigate = useNavigate();
  return (
    <div className="mb-6 flex flex-wrap items-center gap-3 rounded-xl border border-slate-200 bg-white px-5 py-4 text-slate-800" data-testid="pioneer-ended-notice">
      <Star className="h-5 w-5 flex-shrink-0 text-slate-500" />
      <p className="flex-1 text-sm sm:text-base">
        O vosso período <strong>Pioneiro</strong> terminou a <strong data-testid="pioneer-ended-date">{ptDate(endedAt)}</strong>. Para continuar a publicar vagas, escolham um plano.
      </p>
      <button onClick={() => navigate('/checkout')} className="rounded-lg bg-blue-600 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-700" data-testid="pioneer-ended-plans-btn">
        Ver planos
      </button>
    </div>
  );
};

export const PioneerCountdownBanner = ({ credits }) => {
  if (credits?.pioneer_ended_at) return <PioneerEndedNotice endedAt={credits.pioneer_ended_at} />;
  const trial = (credits?.active_packs || []).find((p) => p.plan_type === 'trial_60');
  if (!trial?.expires_at) return null;
  const n = daysLeft(trial.expires_at);
  return (
    <div className="mb-6 flex items-center gap-3 rounded-xl border border-blue-200 bg-blue-50 px-5 py-4 text-blue-900" data-testid="pioneer-countdown-banner">
      <Star className="h-5 w-5 flex-shrink-0 text-blue-700" />
      <p className="text-sm sm:text-base">
        <strong>Pioneiro</strong> · faltam <strong data-testid="pioneer-days-left">{n} {n === 1 ? 'dia' : 'dias'}</strong>, termina a <strong data-testid="pioneer-end-date">{ptDate(trial.expires_at)}</strong>
      </p>
    </div>
  );
};
